import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";
import { getProfile } from "../../core/service/users.service";
import moment from "moment";
// material
import { styled } from "@mui/material/styles";
import { Card, CardHeader } from "@mui/material";

// ----------------------------------------------------------------------

const CHART_HEIGHT = 372;
const LEGEND_HEIGHT = 72;

const ChartWrapperStyle = styled("div")(({ theme }) => ({
  height: 340,
  marginTop: theme.spacing(5) - 10,
  "& .apexcharts-canvas svg": { height: CHART_HEIGHT },
  "& .apexcharts-canvas svg,.apexcharts-canvas foreignObject": {
    overflow: "visible"
  },
  "& .apexcharts-legend": {
    height: LEGEND_HEIGHT,
    alignContent: "center",
    position: "relative !important",
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`
  }
}));

// ----------------------------------------------------------------------

export default function ContractTimeChartPhd() {
  const { user: currentUser } = useSelector((state) => state.authReducer);
  const { id } = currentUser;
  const [contractTime, setContractTime] = useState(0);
  const getUserProfile = async (id) => {
    const data = await getProfile(id);

    const contract_end = moment(data?.student_phd_information?.contract_end);
    const start_reciving = moment(
      data?.student_phd_information?.start_reciving
    );
    const date_now = moment();
    const length_start_and_endDate = contract_end.diff(start_reciving, "days");
    const now_date = date_now.diff(start_reciving, "days");

    setContractTime(
      ((now_date / length_start_and_endDate) * 100).toFixed(2) || 0
    );
  };

  useEffect(() => {
    getUserProfile(id);
  }, []);

  const CHART_DATA = [contractTime];

  const chartOptions = {
    colors: ["#0070C0"],
    labels: ["Progress"],
    legend: { show: false },
    dataLabels: {
      enabled: false,
      formatter: function (val) {
        return val;
      },
      dropShadow: { enabled: true }
    },
    plotOptions: {
      radialBar: { hollow: { size: "50%" } }
    }
  };

  return (
    <Card>
      <CardHeader title="Contract Time" />
      <ChartWrapperStyle dir="ltr">
        <ReactApexChart
          type="radialBar"
          series={CHART_DATA}
          options={chartOptions}
          height={360}
        />
      </ChartWrapperStyle>
    </Card>
  );
}
